<template>
  <div :style="containerStyle" class="responsive-wrapper">
    <span v-show="responisve" @click="openContainer=!openContainer" :style="filterStyle">
      <i v-show="toastIcon" :class="toastIcon"></i>
      <i v-show="!toastIcon" class="material-icons">youtube_searched_for</i>
    </span>
    <transition name="el-zoom-in-center">
      <div v-show="openContainer" :style="(openContainer)?'':''" class="responsive-items">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ResponsivePanel",
  props: [
    "right",
    "left",
    "heightResponsive",
    "goResponsive",
    "toastIcon",
    "floatToast"
  ],
  data() {
    return {
      responisve: false,
      openContainer: true
    }; //old val in watcher doesnot work??
  },
  computed: {
    filterStyle() {
      if (this.floatToast) {
        var stl = {
          width: "35px",
          height: "35px",
          backgroundColor: "#73daa8bf",
          color: "white",
          zIndex: 2,
          position: "fixed",
          // right: '-10px',
          borderRadius: "50%",
          boxShadow: "4px 3px 7px grey",
          marginTop: "-15px",
          paddingLeft: "3px",
          paddingTop: "5px"
        };
        if (this.right != undefined)
          stl.right =
            this.right && this.right != "" ? this.right + "px" : "15px";
        if (this.openContainer) stl.marginTop = "-30px";

        return stl;
      }
      return null;
    },
    containerStyle() {
      if (!this.responisve)
        return {
          height: "auto",
          width: "100%"
        };
      else {
        if (this.openContainer)
          return {
            height: "auto",
            width: "100%"
          };
        else
          return {
            height: "0px",
            width: "100%"
          };
      }
    }
  },
  watch: {
    goResponsive(val) {
      if (val != undefined) this.responisve = val;
    }
  },
  methods: {},
  mounted() {
    if (this.goResponsive != undefined) {
      this.responisve = this.goResponsive;
      this.openContainer = !this.responisve;
      return;
    }
    const hR = this.heightResponsive ? this.heightResponsive : 800;
    _log_("hefisfd....", hR, window.innerHeight);
    if (hR > window.innerHeight) {
      this.responisve = true;
      this.openContainer = false;
    } else this.responisve = false;
  }
};
</script>

<style >
.responsive-items {
  display: flex;
  flex-grow: 1;
}
.responsive-wrapper {
  display: flex;
  flex-grow: 1;
}
</style>
